export default __webpack_public_path__ + "static/media/8829.f6af89ba.svg";